import React, { useEffect, useState } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import './Extensions.css';
import { FieldProps, FieldValidation } from '@rjsf/core';
import { FormControl, TextField, makeStyles } from '@material-ui/core';
import { appThemeApiRef, useApi } from '@backstage/core-plugin-api';

type dateType = {
  date: string;
  dateTitle: string;
};

export const CustomDatePicker = ({ onChange }: FieldProps<string>) => {
  const [value, setValue] = useState<Dayjs | null>(null);

  const [formState, setFormState] = useState<dateType>({
    date: '',
    dateTitle: '',
  });

  const Date = () => {
    const themeApi = useApi(appThemeApiRef);
    return (
      <div id={themeApi.getActiveThemeId() === 'dark-theme' ? 'dark' : 'light'}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            sx={{
              border: '1px solid #ced4da',
            }}
            label="Date of Incident"
            value={value}
            onChange={newValue => {
              setValue(newValue);
              handleDate(newValue);
            }}
            renderInput={params => <TextField {...params} />}
          />
        </LocalizationProvider>
      </div>
    );
  };

  function handleDate(dateVal: Dayjs | null) {
    if (dateVal !== null && dateVal !== undefined) {
      if (!dayjs(dateVal.$d, 'MM/DD/YYYY').isValid()) {
        const year: string = dateVal.$d.getFullYear();

        let month: string = (1 + dateVal.$d.getMonth()).toString();
        month = month.length > 1 ? month : `0${month}`;

        let day: string = dateVal.$d.getDate().toString();
        day = day.length > 1 ? day : `0${day}`;

        setFormState({
          date: `${month}/${day}/${year}`.toString(),
          dateTitle: `${month}${day}${year}`.toString(),
        });
      }
    }
  }

  onChange(formState);

  return (
    <FormControl margin="normal">
      <Date />
    </FormControl>
  );
};

export const dateValidation = (
  value: dateType,
  validation: FieldValidation,
) => {
  if (value === null) {
    validation.addError('Please select a valid date');
  }

  if (value === undefined) {
    validation.addError('Please select a valid date');
  }

  if (Object.keys(value).length === 0) {
    validation.addError('Please select a valid date');
  }

  if (
    Object.keys(value).length !== 0 &&
    value !== null &&
    value !== undefined
  ) {
    if (!dayjs(value.date, 'MM/DD/YYYY').isValid()) {
      validation.addError('Please select a valid date');
    }
  }
};
